export enum EventType {
    SPLASH_SCREEN = 'SplashScreen',
    SIGN_IN = 'SignIn',
    FORGOT_PASSWORD = 'ForgotPassword',
    NEW_ACCOUNT = 'NewAccount',
    TERMS = 'TermsAndConditions',
    PICKUP_LOCATION = 'PickupLocation',
    PREFERENCES = 'Preferences',
    JOB_DETAILS = 'JobDetails',
    COMPLETED_JOBS = 'CompletedJobs',
    COMPLETED_JOB = 'CompletedJob',
    PUBLISHED_JOB = 'PublishedJob',
    VIEW_BIDS = 'ViewBids',
    BID_ACCEPTED = 'BidAccepted',
    REVIEW_HAULER = 'ReviewHauler',
    ADDITIONAL_ITEM = 'AdditionalItem',
    CONTACT_US = 'ContactUs',
    SET_AVAILABILITY = 'SetAvailability',
    CHAT = 'Chat'
}

export interface Event {
    eventType: EventType
    width: number
    height: number
}

export class EventService {
    static pushEvent(event: Event) {
        // console.log(event)
        if (window !== top) {
            top.postMessage(event, '*')
        } else {
            //   console.log('Try to send event: \'' + event + '\' to self')
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/events/events.ts